import { render, staticRenderFns } from "./LoadingMessage.vue?vue&type=template&id=3a40afb0&"
import script from "./LoadingMessage.vue?vue&type=script&lang=js&"
export * from "./LoadingMessage.vue?vue&type=script&lang=js&"
import style0 from "./LoadingMessage.vue?vue&type=style&index=0&id=3a40afb0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports